import ResultsModel from '../Apis/Results'
import Controller from './Controller'

export default class ResultsController extends Controller {
  constructor() {
    super(new ResultsModel())
  }
}
